/**
 * Thin, safe wrapper over localStorage so the rest of the code never touches
 * the Web Storage API directly (and so it can be swapped for a server-backed
 * store later without changing callers).
 */

function hasLocalStorage(): boolean {
  try {
    return typeof localStorage !== 'undefined';
  } catch {
    return false;
  }
}

export const storage = {
  get(key: string): string | null {
    if (!hasLocalStorage()) return null;
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  set(key: string, value: string): boolean {
    if (!hasLocalStorage()) return false;
    try {
      localStorage.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  },

  remove(key: string): void {
    if (!hasLocalStorage()) return;
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  },

  getJSON<T>(key: string): T | null {
    const raw = this.get(key);
    if (raw === null) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return null;
    }
  },

  setJSON(key: string, value: unknown): boolean {
    try {
      return this.set(key, JSON.stringify(value));
    } catch {
      return false;
    }
  },
};
